export const chartData = {
    labels: ["abierta", "adjudicada", "anulada", "perdida"],
    datasets: [
      {
        label: "Estado",
        data: [1, 2, 0, 0],
        backgroundColor: ["#0288D1", "#7CB342", "#E0E0E0", "#FBC02D"], // Colors approximate to image
        borderWidth: 0,
      },
    ],
};

export const chartOptions = {
    maintainAspectRatio: false,
    aspectRatio: 0.8,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 2.5,
        ticks: {
          stepSize: 0.5
        }
      },
      x: {
        grid: {
          display: false
        }
      }
    },
};

export const goalChartOptions = {
    maintainAspectRatio: false,
    aspectRatio: 0.8,
    plugins: {
      legend: {
        display: true,
        position: 'bottom'
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 20
        }
      },
      x: {
        grid: {
          display: false
        }
      }
    },
};
